import { AxiosError } from 'axios';

export const handleError = (error: AxiosError) => {
  if (typeof error === 'string') return error;
  return Object.values(error).flat().join(', ');
};
